<template>
    <div class="section">
        <div class="container" style="max-width: 600px;">
            <div v-if="!submitted">
                <div class="has-text-centered mb-5">
                    <span class="icon is-large" style="font-size: 2.5rem; color: #4f46e5;">
                        <i class="fas fa-hand-holding-heart"></i>
                    </span>
                    <h1 class="title is-4 mt-3">I got more to offer!</h1>
                    <p class="subtitle is-6 has-text-grey">Select the areas where you'd like to contribute.</p>
                </div>

                <div class="offer-grid">
                    <div
                        v-for="option in options"
                        :key="option.value"
                        class="offer-card"
                        :class="{ 'is-selected': selectedAreas.includes(option.value) }"
                        @click="toggleArea(option.value)"
                    >
                        <span class="offer-card__icon">
                            <i :class="['fas', option.icon]"></i>
                        </span>
                        <span class="offer-card__label">{{ option.label }}</span>
                        <span class="offer-card__desc">{{ option.description }}</span>
                        <span v-if="selectedAreas.includes(option.value)" class="offer-card__check">
                            <i class="fas fa-check-circle"></i>
                        </span>
                    </div>
                </div>

                <div v-if="error" class="notification is-danger is-light mt-4" style="border-radius: 12px;">
                    <button class="delete" @click="error = null"></button>
                    {{ error }}
                </div>

                <div class="has-text-centered mt-5">
                    <button
                        class="button is-primary is-rounded"
                        :disabled="selectedAreas.length === 0 || isSubmitting"
                        :class="{ 'is-loading': isSubmitting }"
                        @click="submit"
                    >
                        Submit
                    </button>
                    <div class="mt-3">
                        <router-link to="/" class="has-text-grey is-size-7">← Back to home</router-link>
                    </div>
                </div>
            </div>

            <div v-else class="has-text-centered">
                <div class="notification is-success is-light" style="border-radius: 16px;">
                    <p class="title is-5">Thank you!</p>
                    <p>We've noted your interest. An Apexian will be in touch soon.</p>
                </div>
                <router-link to="/" class="button is-rounded mt-4">Back to home</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectedAreas: [],
            isSubmitting: false,
            submitted: false,
            error: null,
            options: [
                { value: 'Food Ordering', label: 'Food Ordering', icon: 'fa-shopping-cart', description: 'Help place food orders and decide what goes in the bag.' },
                { value: 'Social Media', label: 'Social Media', icon: 'fa-share-alt', description: 'Create content and spread the word about our mission.' },
                { value: 'Web App Development', label: 'Web App Development', icon: 'fa-code', description: 'Build and improve the tools volunteers and admins use.' },
                { value: 'Organise Events with Beneficiaries', label: 'Organise Events with Beneficiaries', icon: 'fa-calendar-check', description: 'Plan and run activities that bring joy to our beneficiaries.' }
            ]
        }
    },
    methods: {
        toggleArea(value) {
            const idx = this.selectedAreas.indexOf(value);
            if (idx === -1) {
                this.selectedAreas.push(value);
            } else {
                this.selectedAreas.splice(idx, 1);
            }
        },
        async submit() {
            this.isSubmitting = true;
            this.error = null;
            try {
                if (!this.$store.getters['user/getCurrentUser']) {
                    await this.$store.dispatch('user/loadUserProfile');
                }
                const user = this.$store.getters['user/getCurrentUser'];
                const userID = this.$store.getters['user/getCurrentUserID'];
                if (!user || !userID) {
                    throw new Error('Could not load your profile. Please sign out and sign in again.');
                }
                await this.$store.dispatch('interests/submitInterest', {
                    volunteerID: userID,
                    volunteerName: user.name,
                    volunteerEmail: user.email,
                    areas: this.selectedAreas
                });
                this.submitted = true;
                this.$store.commit('interests/setHasSubmitted', true);
            } catch (e) {
                this.error = e.message || 'Something went wrong. Please try again.';
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}
</script>

<style scoped>
.offer-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.85rem;
}

.offer-card {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    padding: 1.25rem 1rem;
    background: #f9fafb;
    border: 2px solid #e5e7eb;
    border-radius: 14px;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
    text-align: center;
}

.offer-card:hover {
    border-color: #a5b4fc;
    background: #f0f4ff;
}

.offer-card.is-selected {
    border-color: #4f46e5;
    background: #eef2ff;
}

.offer-card__icon {
    font-size: 1.75rem;
    color: #4f46e5;
}

.offer-card__label {
    font-size: 0.9rem;
    font-weight: 600;
    color: #1f2937;
    line-height: 1.3;
}

.offer-card__desc {
    font-size: 0.78rem;
    color: #6b7280;
    line-height: 1.4;
}

.offer-card__check {
    position: absolute;
    top: 0.5rem;
    right: 0.6rem;
    color: #4f46e5;
    font-size: 1.1rem;
}
</style>
